const PUBLIC_MAP_STYLES = {
  DEFAULT: 'https://tiles.atlas.mchs.gov.ru/api/maps/basic/style.json',
  DARK: 'https://tiles.atlas.mchs.gov.ru/api/maps/basic-dark/style.json',
  OUTLINED: 'https://tiles.atlas.mchs.gov.ru/api/maps/outlined/style.json',
};

const PRIVATE_MAP_STYLES = {
  DEFAULT: 'https://tiles.atlas.mchs.ru/api/maps/bright/style.json',
  DARK: 'https://tiles.atlas.mchs.ru/api/maps/basic-dark/style.json',
  OUTLINED: 'https://tiles.atlas.mchs.ru/api/maps/outlined/style.json',
  SEA_MAP: '/sea-map-style.json',
};

export const PUBLIC_MAP_STYLE_LIST = [
  { key: 'default', style: PUBLIC_MAP_STYLES.DEFAULT, title: 'Светлая карта' },
  { key: 'darkatlas', style: PUBLIC_MAP_STYLES.DARK, title: 'Темная карта' },
  { key: 'outlined', style: PUBLIC_MAP_STYLES.OUTLINED, title: 'Географические границы' },
];

export const PRIVATE_MAP_STYLE_LIST = [
  { key: 'default', style: PRIVATE_MAP_STYLES.DEFAULT, title: 'Светлая карта' },
  { key: 'darkatlas', style: PRIVATE_MAP_STYLES.DARK, title: 'Темная карта' },
  { key: 'outlined', style: PRIVATE_MAP_STYLES.OUTLINED, title: 'Географические границы' },
  { key: 'seas', style: PRIVATE_MAP_STYLES.SEA_MAP, title: 'Карта морей' },
];
